module.exports = __webpack_public_path__ + "img/38.20c630e3.jpg";